import React, { useState, useEffect } from "react";
import MainHeader from "../../components/mainheader";
import MainContainer from "../../components/maincontainer";
import Main from "../../assets/main.svg";
import SubCat from "../../assets/subcat.svg";
import Catorder from "../../assets/catord.svg";
import Manage from "../../assets/manage.svg";
import Import from "../../assets/import.svg";
import View from "../../assets/view.svg";
import Create from "../../assets/create.svg";
import QuizZoneTable from "../../components/tables/quiz-zone-table";
import CreateCategory from "../../components/modals/create-category";
// import CreateSubCategory from "../../components/modals/create-sub-category";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
	LoadMore,
	LoadingLoader,
	MainPaginate,
} from "../../components/buttons/button";
import { manageQuizZone } from "../../data/Reducers/QuizZoneReducer";

const QuizZone = () => {
	const [modal, setModal] = useState(""),
		navigate = useNavigate();
	const handleClose = () => {
		setModal("");
	};
	const Arr = [
		{
			title: "Main category",
			img: Main,
			bg: "#F7F8FF",
			action: () => setModal("create-category"),
		},
		{
			title: "sub category",
			img: SubCat,
			bg: "#F7FFF7",
			action: () => setModal("create-sub-category"),
		},
		{
			title: "category order",
			img: Catorder,
			bg: "#FCEEFF",
			action: () => navigate("/category-order"),
		},
		{
			title: "Question Report",
			img: Manage,
			bg: "#F4FFF1",
			action: () => navigate("/quiz-zone/question-report"),
		},
		{
			title: "View Questions",
			img: View,
			bg: "#FFFFF7;",
			action: () => navigate("/overview/questions"),
		},
		{
			title: "import questions",
			img: Import,
			bg: "#F7F8FF",
			action: () => navigate("/bulk-upload", { state: { type: "quizZone" } }),
		},
		{
			title: "create questions",
			img: Create,
			bg: "#FFF2F9",
			action: () => navigate("/quiz-zone/create-questions"),
		},
	];
	const Headers = [
		"Image",
		"Question",
		"category",
		"sub-category",
		"Answer",
		"timeline",
		"Actions",
	];
	const tableData = [
		{
			quiz_id: "25",
			category: "English",
			sub_category: "General Knowledge",
			total_question: "20",
			timeline: "60 secs",
		},
		{
			quiz_id: "25",
			category: "English",
			sub_category: "General Knowledge",
			total_question: "20",
			timeline: "60 secs",
		},
		{
			quiz_id: "25",
			category: "English",
			sub_category: "General Knowledge",
			total_question: "20",
			timeline: "60 secs",
		},
		{
			quiz_id: "25",
			category: "English",
			sub_category: "General Knowledge",
			total_question: "20",
			timeline: "60 secs",
		},
	];

	let { quizZone } = useSelector(s => s),
		[data, setData] = useState(null),
		dispatch = useDispatch();

	useEffect(() => {
		setData(quizZone?.data);
	}, [quizZone?.data]);

	useEffect(() => {
		dispatch(manageQuizZone("get", null));
	}, [dispatch]);

	let [range] = useState(10),
		[page, setPage] = useState(1),
		[loading, setLoading] = useState(null);

	const [itemOffset, setItemOffset] = useState(0);
	const endOffset = itemOffset + range;

	if (!data && !quizZone?.data) return <LoadingLoader />;

	const currentItems = data?.docs?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(data?.docs?.length / range);

	const handlePageClick = event => {
			const newOffset = (event.selected * range) % data?.docs?.length;
			setItemOffset(newOffset);
			setPage(1 + event?.selected);
		},
		handleLoadMore = async () => {
			setLoading("loadmore");
			let datum = { limit: data?.limit * data?.nextPage };
			await dispatch(manageQuizZone("get", datum));
			setLoading(false);
		};

	return (
		<div>
			<MainHeader text={"Quiz Zone"} />
			<MainContainer>
				<div className="tw-grid tw-mt-2 tw-grid-cols-4 tw-gap-8">
					{Arr.map((item, i) => (
						<div
							key={i}
							onClick={item.action}
							style={{
								background: item.bg,
							}}
							className={`myShadow2 tw-rounded-md tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-h-28`}>
							<div>
								<img src={item?.img} alt={item?.title} className="tw-mx-auto" />
								<h4 className="tw-text-base sansation tw-mt-2 tw-font-bold tw-text-center tw-text-main tw-capitalize">
									{item.title}
								</h4>
							</div>
						</div>
					))}
				</div>
				<div className="tw-mt-10 tw-pb-10">
					<QuizZoneTable data={currentItems || tableData} headers={Headers} />
					<div className="tw-mt-4 tw-flex tw-justify-center">
						<LoadMore
							next={page === pageCount && data?.hasNextPage}
							loading={loading === "loadmore"}
							handleLoadMore={handleLoadMore}
						/>
					</div>
					<div className="tw-mt-4 tw-flex tw-justify-center">
						{/* <Pagination /> */}
						<MainPaginate
							pageCount={pageCount}
							handlePageClick={handlePageClick}
						/>
					</div>
				</div>
			</MainContainer>
			{modal === "create-category" && (
				<CreateCategory handleClose={handleClose} subType="quizZone" />
			)}
			{modal === "create-sub-category" && (
				<CreateCategory
					handleClose={handleClose}
					type="sub category"
					subType="quizZone"
				/>
				// <CreateSubCategory handleClose={handleClose} />
			)}
		</div>
	);
};

export default QuizZone;
